/**
 * Created by DELL on 2017/3/1.
 */
import {
  CHECK_TREE,
  DELETE_TREE,
  TREE_CHECK,
  TREE_DELETE
} from '../types'
// import tabArr from '../../../utils/tabArr'
const authModule = {
  state: {
    selectId: ''
  },
  mutations: {
    [TREE_CHECK] (state, id) {
      // tabArr.addTab(state.treeList, id)
      state.selectId = id
    },
    [TREE_DELETE] (state, id) {
      // tabArr.removeTab(state.treeList, id)
      if (state.selectId === id) state.selectId = ''
    }
  },
  actions: {
    [CHECK_TREE] ({commit}, id) {
      commit(TREE_CHECK, id)
    },
    [DELETE_TREE] ({commit}, id) {
      commit(TREE_DELETE, id)
    }
  },
  getters: {
  }
}
export default authModule



// WEBPACK FOOTER //
// ./src/store/modules/tree.js